<jml-lib-dynamic-table
  *ngIf="entitySelectionListTableData"
  [tableData]="entitySelectionListTableData"
  (entitySelectionListChanged)="propagateChange($event)"
  [isRootEntity]="false"
></jml-lib-dynamic-table>
